/**
 * Same character rules as "Descripción del Incidente" (form-attribute textarea).
 */
export const INCIDENT_LONG_TEXT_CHAR =
  /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s\-_.',":;*()¿?¡!]$/;

export const INCIDENT_LONG_TEXT_VALUE =
  /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s\-_.',":;*()¿?¡!]*$/;

/** Paste allows a slightly wider set (matches form-attribute onPasteTextarea). */
export const INCIDENT_LONG_TEXT_PASTE =
  /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑ\s\-_@.+',";:*()¿?¡!]*$/;

export function hasInvalidIncidentLongText(value: string | null | undefined): boolean {
  if (value == null || value === '') {
    return false;
  }
  return !INCIDENT_LONG_TEXT_VALUE.test(String(value));
}

export function blockIncidentLongTextKeypress(event: KeyboardEvent): void {
  const char = event.key;
  // Allow control / navigation keys (Enter, Backspace, arrows, etc.).
  if (char.length !== 1) {
    return;
  }

  const target = event.target as HTMLTextAreaElement | HTMLInputElement;
  const selectionStart = target?.selectionStart ?? 0;

  if (selectionStart === 0 && char === ' ') {
    event.preventDefault();
    return;
  }

  if (!INCIDENT_LONG_TEXT_CHAR.test(char)) {
    event.preventDefault();
  }
}

export function blockIncidentLongTextPaste(event: ClipboardEvent): void {
  const clipboardData = event.clipboardData?.getData('text') || '';
  if (!INCIDENT_LONG_TEXT_PASTE.test(clipboardData)) {
    event.preventDefault();
  }
}
